var _style, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.gold-stroke{fill:none;stroke:#DBB564;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.blue-stroke{fill:none;stroke:#254A8F;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "gold-stroke",
    cx: 12,
    cy: 12,
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "blue-stroke",
    d: "M19.4,15c-0.3,0.6-0.1,1.3,0.3,1.8l0.1,0.1c0.8,0.8,0.8,2,0,2.8c0,0,0,0,0,0c-0.8,0.8-2,0.8-2.8,0c0,0,0,0,0,0 l-0.1-0.1c-0.5-0.5-1.2-0.6-1.8-0.3c-0.6,0.3-1,0.9-1,1.5V21c0,1.1-0.9,2-2,2s-2-0.9-2-2v-0.1c0-0.7-0.4-1.3-1.1-1.5 c-0.6-0.3-1.3-0.1-1.8,0.3l-0.1,0.1c-0.8,0.8-2,0.8-2.8,0c0,0,0,0,0,0c-0.8-0.8-0.8-2,0-2.8c0,0,0,0,0,0l0.1-0.1 c0.5-0.5,0.6-1.2,0.3-1.8c-0.3-0.6-0.9-1-1.5-1H3c-1.1,0-2-0.9-2-2s0.9-2,2-2h0.1c0.7,0,1.3-0.4,1.5-1.1c0.3-0.6,0.1-1.3-0.3-1.8 L4.2,7.1c-0.8-0.8-0.8-2,0-2.8c0,0,0,0,0,0c0.8-0.8,2-0.8,2.8,0c0,0,0,0,0,0l0.1,0.1C7.6,4.8,8.3,5,8.9,4.7H9c0.6-0.3,1-0.9,1-1.5V3 c0-1.1,0.9-2,2-2s2,0.9,2,2v0.1c0,0.7,0.4,1.3,1,1.5c0.6,0.3,1.3,0.1,1.8-0.3l0.1-0.1c0.8-0.8,2-0.8,2.8,0c0,0,0,0,0,0 c0.8,0.8,0.8,2,0,2.8c0,0,0,0,0,0l-0.1,0.1c-0.5,0.5-0.6,1.2-0.3,1.8V9c0.3,0.6,0.9,1,1.5,1H21c1.1,0,2,0.9,2,2s-0.9,2-2,2h-0.1 C20.3,14,19.7,14.4,19.4,15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.d29b7403.svg";
export { ForwardRef as ReactComponent };